import { render } from "./ServiceRequestView.vue?vue&type=template&id=524fa108&scoped=true"
import script from "./ServiceRequestView.vue?vue&type=script&lang=js"
export * from "./ServiceRequestView.vue?vue&type=script&lang=js"

import "./ServiceRequestView.vue?vue&type=style&index=0&id=524fa108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524fa108"]])

export default __exports__